window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.base = {
    headers: function () {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'RequestVerificationToken': casino.config.antiForgeryToken
        }
    },
    credentials: 'include',
    serializeGetParams: function (obj) {
        return '?' + Object.keys(obj).reduce(function (a, k) {
            a.push(k + '=' + encodeURIComponent(obj[k]));
            return a
        }, []).join('&')
    },
    checkResponse: function (response) {
        if (response.status !== 200) {
            throw response;
        }
        return response;
    },
    handleNetworkException: function (error) {
        if (casino.repos.base.networkErrorsListener != null)
            casino.repos.base.networkErrorsListener(error);
    },
    networkErrorsListener: null
};